module.exports = __webpack_public_path__ + "img/组 126@2x(1).5f14170f.png";